export default __webpack_public_path__ + "static/media/Mukta-ExtraBold.b1fa1110.ttf";